import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { FilterControlsProps, FilterType } from './types'

export default function FilterControls({
    filter,
    period: _period,
    onFilterChange,
    onPeriodChange: _onPeriodChange,
}: FilterControlsProps) {
    const { t } = useTranslation('report')

    const filterTabs: { label: string; value: FilterType }[] = [
        {
            label: t('target_analytics.filter.all', 'Tất cả'),
            value: 'all',
        },
        {
            label: t('target_analytics.filter.not_achieved', 'Chưa đạt'),
            value: 'not_achieved',
        },
        {
            label: t('target_analytics.filter.achieved', 'Đạt'),
            value: 'achieved',
        },
    ]

    return (
        <div className="flex items-center justify-between">
            {/* Filter Tabs */}
            <div className="flex items-center gap-1 bg-white p-1 rounded-lg">
                {filterTabs.map((tab) => (
                    <button
                        key={tab.value}
                        onClick={() => onFilterChange(tab.value)}
                        className={cn(
                            'px-5 py-2 rounded text-sm font-semibold transition-colors',
                            filter === tab.value
                                ? 'bg-[#F3F8FF] text-[#1A237E]'
                                : 'text-gray-500 hover:bg-gray-50'
                        )}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Period Selector */}
            {/* <Select
                value={period}
                onValueChange={(value) => onPeriodChange(value as PeriodType)}
            >
                <SelectTrigger className="w-32">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {periodOptions.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select> */}
        </div>
    )
}
